export default __webpack_public_path__ + "static/media/admin-type.f98b220d.svg";